var e = /* @__PURE__ */ ((r) => (r.Primary = "primary", r.Secondary = "secondary", r.Tertiary = "tertiary", r.Link = "link", r.Danger = "danger", r.Positive = "positive", r.Negative = "negative", r))(e || {});
const n = [
  "primary",
  "secondary",
  "tertiary",
  "link",
  "danger",
  "positive",
  "negative"
];
var i = /* @__PURE__ */ ((r) => (r.Button = "button", r.Reset = "reset", r.Submit = "submit", r))(i || {});
const v = ["button", "reset", "submit"];
var a = /* @__PURE__ */ ((r) => (r.Active = "iress--active", r.Base = "iress-u-button", r.Fluid = "iress--fluid", r.Loading = "iress--loading", r.Mode = "iress--mode", r.NoWrap = "iress--no-wrap", r.Prepend = "iress-u-button__prepend", r))(a || {});
export {
  n as BUTTON_MODES,
  v as BUTTON_TYPES,
  a as ButtonCssClass,
  e as ButtonMode,
  i as ButtonType
};
